import { deliveryStatusStyle, uurlTestToolStyle } from '@bingads-webui-campaign-react/common-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { getSharedGlobalStyles } from './shared';

const budgetLandscapeTable = {
  '& .budget-landscape-container': {
    marginRight: '32px',

    '& .landscape-table': {
      '& .tip-message, & .error-message': {
        '& span.iconba-Warning': {
          marginRight: '5px',
          color: '#D83B01',
        },
        marginBottom: '16px',
        marginTop: '16px',
        marginLeft: '8px',
      },
      '& table': {
        width: '100%',
        '& input': {
          marginRight: '8px',
        },
        '& input[type=\'radio\']': {
          position: 'relative',
          marginLeft: '4px',
        },
        '& th, & td': {
          '&.selected': {
            background: 'rgba(237, 237, 237, 0.5)',
          },
        },

        '& td.user-input-cell': {
          paddingLeft: '1px',
        },

        '& tr': {
          height: '32px',
        },

        '& th': {
          '&.selected': {
            color: '#333',
            fontWeight: '500',
          },
        },
        '& td:last-child': {
          paddingRight: '5px',
        },
        '& .user-input': {
          display: 'inline',
          position: 'relative',
          '& .currency-symbol': {
            position: 'absolute',
            top: '-1px',
            left: '6px',
            color: '#666666',
          },

          '& input': {
            paddingLeft: '16px',
            borderWidth: '1px',
            borderColor: '#BBB',
          },

          '& .symbol-size-2 + input': {
            paddingLeft: '25px',
          },

          '& .symbol-size-3 + input': {
            paddingLeft: '35px',
          },

          '& .error': {
            color: '#A80000 !important',
            fontSize: 'inherit',
          },
        },
        '& tbody': {
          '& tr.selected': {
            backgroundColor: '#F3F2F1',
          },
        },
        '& thead': {
          '& span': {
            fontWeight: '500',
            marginLeft: '10px',
          },
        },
      },
    },
  },
};

const budGetEditTitle = {
  '& .title-container': {
    marginBottom: '16px',
    marginRight: '32px',
    position: 'relative',
    '& .title': {
      fontSize: '20px',
      fontWeight: '500',
      overflowWrap: 'break-word',
    },
    '& .iconba-Cancel': {
      position: 'absolute',
      top: '0px',
      right: '-32px',
    },
  },
};

export default (components, { palette }) => ({
  '.grid-popupeditor .campaigns-date-picker': {
    marginBottom: 16,
    position: 'relative',

    '& label': {
      position: 'relative',
      top: '-5px',
    },

    '& input': {
      marginRight: '7.5px',
    },

    '& > div': {
      width: '8em',
    },
  },
  '.grid-popupeditor.final-url-suffix-inline-edit-popup': {
    width: 310,
  },
  '.grid-popupeditor .custom-content': {
    marginBottom: 16,
  },
  '.grid-popupeditor .custom-params-template': {
    marginBottom: 16,
    width: 456,
    '& .flex-row-fixed, & .flex-row-dynamic': {
      display: 'inline-block',

      '& .custom-param__key-field': {
        display: 'inline-block',
        width: '150px',
      },

      '& label.control-label': {
        margin: '0 5px',
      },
    },
    '& .custom-param-entry': {
      display: 'block',
      marginBottom: 10,
      '& .iconba-Cancel': {
        fontSize: '16px',
        marginLeft: 5,
        cursor: 'pointer',
      },
    },
  },
  '.grid-popupeditor.tracking-template-inline-edit-popup': {
    width: 450,
    '& .charactersRemaining': {
      marginTop: 5,
      marginBottom: 5,
    },
    '& .font-error': {
      marginTop: 5,
      marginBottom: 5,
    },
    ...uurlTestToolStyle({ palette }),
    '& .full-width, & input[type="text"].full-width': {
      width: '100%',
    },
    '& input.with-test-button': {
      width: '80%',
      display: 'inline-block',
    },
    '& input.testUurl.btn.btn-default': {
      height: 27,
    },
    '& .uurl-test-tool__container': {
      verticalAlign: 'middle',
      float: 'right',
    },
    '& .uurl-test-info__container': {
      lineHeight: '15px',
      marginTop: -5,
      marginBottom: 10,
    },
    '& .tracking-template__container input.testUurl, & .tracking-template-inline-edit-popup input.testUurl': {
      float: 'right',
      height: 21,
      lineHeight: '14px',
    },
    '& .popup--uurl-detail': {
      maxHeight: '350px !important',
    },
  },
  '.grid-popupeditor > .bid-adjustment-view': {
    '& .input[role="listbox"]': {
      marginRight: 10,
    },
    '& .bid-adjustment-input-group': {
      display: 'inline-table',
      verticalAlign: 'middle',
      '& .form-control, .input-group-addon, .input-group-btn': {
        width: 'auto',
      },
      '& > .form-control': {
        width: '100%',
      },
    },
    '& .input-group-addon': {
      background: 'transparent',
      border: 'none',
    },
    '& .bid-adjustment-margin-bottom': {
      marginBottom: '15px',
    },
    '& .form-horizontal': {
      '& .form-group': {
        marginBottom: 0,
      },
      '& .form-group ~ .form-group': {
        marginTop: 0,
      },
      '& .form-validation-container': {
        transform: 'translateY(-10px)',
      },
      '& .performance_clicks, .performance_conversions, .performance_impressions': {
        color: palette.themePrimary,
        fontWeight: 'bold',
      },
      '& .bid-adjustment-manual-content': {
        marginTop: '5px',
        '& select.form-control': {
          width: '160px',
          marginRight: '9px',
          display: 'inline-block',
          verticalAlign: 'middle',
        },
        '& .bid-adjustment-input-group input.form-control': {
          width: '75px',
          display: 'inline-block',
        },
      },
      '& .bid-adjustment-options': {
        '& .radio': {
          paddingTop: 0,
        },
        '& input[type=radio] ~ div': {
          marginLeft: '8px',
        },
        '& .bid-adjustment-margin-bottom': {
          marginBottom: '15px',
        },
      },
    },
  },
  '.font-error': {
    '& > ul': {
      listStyle: 'none',
      paddingLeft: 0,
      margin: 0,
      '& > li': {
        margin: '5px 0px 0px 0px',
      },
      '& > li:empty': {
        margin: 0,
      },
    },
  },
  '.grid-popupeditor .inline-budget-editor': {
    '& .alert': {
      padding: '8px 32px 8px 8px',
      '& .alert-image': {
        float: 'left',
      },
      '& .alert-info-inline': {
        color: 'black',
      },
      '& .bold': {
        fontWeight: 1000,
      },
      '& .alert-budget-button': {
        marginLeft: '10px',
        paddingTop: '5px',
        '& button': {
          color: 'black',
          fontSize: '13px',
          fontWeight: 500,
          borderColor: palette.neutralLight,
        },
      },
    },
    ' & .error': {
      fontSize: '14px',
    },

    '& > ul': {
      listStyle: 'none',
    },
    '& .display-inline': {
      display: 'block',
      marginBottom: '16px',

      '& .inline-budget-edit-value': {
        display: 'inline-block',
        verticalAlign: 'top',
        marginRight: '10px',
        width: 'auto',
      },

      '& .inline-budget-edit-type': {
        display: 'inline-block',
        width: 'auto',
      },
    },

    ...budGetEditTitle,
    ...budgetLandscapeTable,

    '& .inline-budget-editor-actions': {
      marginTop: '16px',
      marginRight: '32px',
    },

    '& .input-budget-container': {
      marginTop: '15px',
      marginRight: '32px',
      '& .budgetText': {
        marginRight: '10px',
      },

      '& .input-box': {
        position: 'relative',
        '& .currency-symbol': {
          position: 'absolute',
          top: '6px',
          left: '5px',
          color: '#666666',
        },

        '& .symbol-size-2 + input': {
          paddingLeft: '25px',
        },

        '& .symbol-size-3 + input': {
          paddingLeft: '35px',
        },

        '& input': {
          marginTop: '5px',
          paddingLeft: '14px',
        },
      },

      '& .error': {
        color: '#A80000 !important',
        fontSize: 'inherit',
      },
    },

    '& .select-budget-container': {
      paddingTop: '16px',
      marginBottom: '5px',
      marginRight: '32px',
      '& .inline-budget-edit-type': {
        marginTop: '5px',
      },
    },

    '& .select-budget-container-with-landscape': {
      paddingTop: '16px',
      marginBottom: '5px',
      marginRight: '32px',
      borderTop: '1px solid #CCCCCC',
      marginTop: '10px',
      '& .inline-budget-edit-type': {
        marginTop: '5px',
      },
    },

    '& .alert-container': {
      marginTop: '0px',
      marginBottom: '5px',
      marginRight: '32px',
    },
  },

  '.shared-budget-inline-editor': {
    ...budGetEditTitle,
    ...budgetLandscapeTable,

    maxWidth: '500px',
    '& .shared-budget-popup-edit-budget': {
      '& .shared-budget-edit-budget-input': {
        display: 'block',
        float: 'left',
        width: '200px',
        marginBottom: '16px',
        marginRight: '16px',
      },

      '& .shared-budget-edit-budget-message-per-day': {
        display: 'block',
        float: 'left',
      },

      '& .shared-budget-edit-budget-save': {
        display: 'block',
        float: 'left',
        clear: 'left',
      },
      '& .shared-budget-edit-budget-cancel': {
        display: 'block',
        float: 'left',
      },
      '& ul': {
        clear: 'both',
      },
    },
  },
  '.target-cpa-inline-editor': {
    maxWidth: '500px',
    '& .title-container': {
      marginBottom: '16px',
      marginRight: '32px',
      position: 'relative',
      '& .title': {
        fontSize: '16px',
        fontWeight: '600',
        overflowWrap: 'break-word',
      },
      '& .iconba-Cancel': {
        position: 'absolute',
        top: '0px',
        right: '-32px',
      },
    },
    '& .input-box': {
      position: 'relative',
      paddingRight: '32px',
      '& .currency-symbol': {
        position: 'absolute',
        top: '11px',
        left: '5px',
        color: '#666666',
      },
      '& .symbol-size-2 + input': {
        paddingLeft: '25px',
      },
      '& .symbol-size-3 + input': {
        paddingLeft: '35px',
      },
      '& input': {
        marginTop: '5px',
        paddingLeft: '14px',
      },
    },
    '& .input-message': {
      marginTop: '8px',
      fontWeight: '600',
      fontSize: '13px',
    },
    '& .alert-info': {
      marginTop: '8px',
      backgroundColor: '#eff6fc',
      borderColor: '#eff6fc',
      color: '#323130',
      display: 'flex',

      '& .alert-image:before': {
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: '16px',
        lineHeight: '10px',
        color: '#605e5c',
        marginRight: '8px',
        marginTop: '8px',
        content: '\'\\E946\'',
      },
      '& .alert-info-inline': {
        fontSize: '12px',
      },
    },
  },
  '.target-impression-share-inline-editor': {
    maxWidth: '300px',
    '& .title-container': {
      marginBottom: '16px',
      marginRight: '32px',
      position: 'relative',
      '& .title': {
        fontSize: '16px',
        fontWeight: '600',
        overflowWrap: 'break-word',
      },
      '& .iconba-Cancel': {
        position: 'absolute',
        top: '0px',
        right: '-32px',
      },
    },
    '& .input-box': {
      position: 'relative',
      '& input': {
        marginTop: '5px',
        marginRight: '4px',
      },
      '& .percent-symbol': {
        position: 'absolute',
        color: '#666666',
        top: '11px',
      },
    },
    '& .alert-info': {
      marginTop: '8px',
      backgroundColor: '#eff6fc',
      borderColor: '#eff6fc',
      color: '#323130',
      display: 'flex',

      '& .alert-image:before': {
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: '16px',
        lineHeight: '10px',
        color: '#605e5c',
        marginRight: '8px',
        marginTop: '8px',
        content: '\'\\E946\'',
      },
      '& .alert-info-inline': {
        fontSize: '12px',
      },
    },
    '& .input-message': {
      marginTop: '8px',
      fontWeight: '600',
      fontSize: '13px',
    },
    '& .ad-position': {
      marginTop: '16px',
      '& .description': {
        marginTop: '5px',
        marginRight: '4px',
      },
      '& label': {
        fontWeight: '200',
      },
    },
  },
  '.target-roas-inline-editor': {
    maxWidth: '300px',
    '& .title-container': {
      marginBottom: '16px',
      marginRight: '32px',
      position: 'relative',
      '& .title': {
        fontSize: '16px',
        fontWeight: '600',
        overflowWrap: 'break-word',
      },
      '& .iconba-Cancel': {
        position: 'absolute',
        top: '0px',
        right: '-32px',
      },
    },
    '& .input-box': {
      position: 'relative',
      '& input': {
        marginTop: '5px',
        marginRight: '4px',
      },
      '& .percent-symbol': {
        position: 'absolute',
        color: '#666666',
        top: '11px',
      },
    },
    '& .alert-info': {
      marginTop: '8px',
      backgroundColor: '#eff6fc',
      borderColor: '#eff6fc',
      color: '#323130',
      display: 'flex',

      '& .alert-image:before': {
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: '16px',
        lineHeight: '10px',
        color: '#605e5c',
        marginRight: '8px',
        marginTop: '8px',
        content: '\'\\E946\'',
      },
      '& .alert-info-inline': {
        fontSize: '12px',
      },
    },
    '& .input-message': {
      marginTop: '8px',
      fontWeight: '600',
      fontSize: '13px',
    },
  },
  'td.grid-column-Campaign, td.grid-column-AdGroup, td.grid-column-AdPreview, td.grid-column-Keyword, td.grid-column-Location': {
    '& .helpbutton::before': {
      position: 'static',
    },
  },
  '.status-popupeditor': {
    position: 'absolute',
    zIndex: '10',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
    minHeight: 50,
    padding: '4px 0',
    margin: '0 18px',
    '& .statusEnabled_icon': {
      verticalAlign: 'text-top',
    },
    '& .statusPaused_icon': {
      verticalAlign: 'text-top',
    },
    '& .statusExcluded_icon': {
      verticalAlign: 'text-top',
    },
    '& .experiment-active-icon': {
      verticalAlign: 'text-top',
    },
    '& .experiment-paused-icon': {
      verticalAlign: 'text-top',
    },
    '& .experiment-excluded-icon': {
      verticalAlign: 'text-top',
    },
    '& ul.grid': {
      listStyle: 'none',
      marginBottom: 0,
      paddingLeft: 0,
      '& .statuschange-icon': {
        marginRight: '5px',
      },
      '& li.statuschangesubtask': {
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: palette.neutralLight,
        },
        '& span.statuschangelink': {
          padding: '5px 15px',
          display: 'block',
        },
      },
    },
  },
  '.table-container .grid-editable-cell': {
    cursor: 'pointer',
  },
  // eslint-disable-next-line no-multi-str
  '.table-container .bidlandscape-column.grid-readonly-cell, \
  .table-container .aggregated-row th[data-column="SearchBid"] .bidlandscape-column, \
  .table-container .aggregated-row td[data-column="SearchBid"] .bidlandscape-column, \
  .table-container .aggregated-row th[data-column="CpmBid"] .bidlandscape-column, \
  .table-container .aggregated-row td[data-column="CpmBid"] .bidlandscape-column, \
  .table-container .aggregated-row th[data-column="CpvBid"] .bidlandscape-column, \
  .table-container .aggregated-row td[data-column="CpvBid"] .bidlandscape-column': {
    '& .bidlandscape-bid-value': {
      marginRight: 25,
    },
  },
  '.table-container .segment-row .segment-value': {
    marginLeft: 14,
  },
  '.table-container .statusicondisplay': {
    '& .statusDraft_icon': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .statusDraft_icon::before': {
      content: '"\\F6B0"',
      color: palette.neutralPrimary,
    },
  },
  '.table-container, .status-popupeditor': {
    '& .statusEnabled_icon': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .statusEnabled_icon::before': {
      content: '"\\ECCC"',
      color: '#107C10',
    },
    '& .statusPaused_icon': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .statusPaused_icon::before': {
      content: '"\\F6B0"',
      color: palette.neutralPrimary,
    },
    '& .statusExcluded_icon': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .statusExcluded_icon::before': {
      content: '"\\E733"',
      color: '#A80000',
    },
    '& .statusDeleted_icon': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .statusDeleted_icon::before': {
      content: '"\\E738"',
      color: '#FF0000',
    },
    '& .experiment-active-icon': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .experiment-active-icon::before': {
      content: '"\\F3A6"',
      color: '#107C10',
    },
    '& .experiment-paused-icon': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .experiment-paused-icon::before': {
      content: '"\\F3A5"',
      color: palette.neutralPrimary,
    },
    '& .experiment-excluded-icon': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .experiment-excluded-icon::before': {
      content: '"\\F880"',
      color: '#A80000',
    },
    '& .statushypendisplay': {
      display: 'inline-block',
      fontFamily: '"MsAds MDL2 Assets"',
      fontSize: 12,
      fontStyle: 'normal',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontWeight: 'normal',
    },
    '& .statushypendisplay::before': {
      content: '"\\E738"',
      color: palette.neutralPrimary,
    },
  },
  '.table-container .glyphicon.glyphicon-pencil': {
    fontFamily: '"MsAds MDL2 Assets"',
    fontStyle: 'normal',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '14px',
    marginLeft: '8px',
  },
  '.table-container .glyphicon.glyphicon-pencil::before': {
    content: '"\\E70F"',
    color: palette.themeDark,
  },
  '.table-container .layout-marked-element.status-row .delivery_status_with_reject_reasons': {
    position: 'relative',
  },
  '.table-container .status_icon:before': {
    content: '"\\E712"',
    fontFamily: '"MsAds MDL2 Assets"',
    display: 'inline-block',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'inherit',
    speak: 'none',
    fontVariant: 'normal',
    textTransform: 'none',
    verticalAlign: 'top',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
  },
  '.table-container .status_icon_hover:before': {
    content: '"\\E712"',
    fontFamily: '"MsAds MDL2 Assets"',
    display: 'inline-block',
    fontWeight: 'normal',
    fontStyle: 'normal',
    textDecoration: 'inherit',
    speak: 'none',
    fontVariant: 'normal',
    textTransform: 'none',
    verticalAlign: 'top',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
  },
  '.table-container .quality-score-detail': {
    float: 'right',
  },
  '#rejectionContainer > div': {
    zIndex: '300',
  },
  '#popover-country': {
    '& .popover-content': {
      padding: '8px 8px 8px 8px',
      textAlign: 'center',
    },
  },
  '#popover-policy': {
    '& .popover-content': {
      padding: '8px 8px 8px 8px',
      textAlign: 'center',
    },
  },
  '#popover-policy-descripts': {
    '& .popover-content': {
      padding: '8px 8px 8px 8px',
      textAlign: 'center',
    },
  },
  '.table-container .mark-container': {
    width: 14,
  },
  '.table-container .status-row': {
    display: 'flex',
    alignItems: 'center',
    '& .decorated-element': {
      marginLeft: 8,
      marginRight: 8,
    },
  },
  '.grid-edit-icon.glyphicon-pencil': {
    verticalAlign: 'middle',
  },

  // language inline edit popup and bulk edit panel
  '.grid-popupeditor div.multi-language-selector': {
    width: '700px',
  },

  '.multi-language-selector': {
    overflow: 'hidden', // child are float element, create bfc to make the container height correct

    '& label.checkbox-inline': {
      marginLeft: '0px',
      paddingLeft: '22px',

      '& > div': {
        display: 'inline-block',
      },
    },
  },

  ...deliveryStatusStyle({ palette }),
  ...getSharedGlobalStyles(components, { palette }),
  '.k-window-content.k-content': {
    outline: 'none',
  },

  '[data-property="Bid/Amount"], [data-property="MatchType"], [data-property="Param1"], [data-property="Param2"], [data-property="Param3"]': {
    '& .form-control': {
      width: '328px',
    },
  },
  '[aria-labelledby="dropdown-column-chooser"] [role="menuitem"]': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    maxWidth: '180px',
  },
  'table.sticky-header': {
    zIndex: Constants.ZIndexContentComponents.GridHeader,
  },
});
